import { useEffect, useState } from "react"
import Button from "../../../button/button"
import InputAnimated from "../../../inputAnimated/inputAnimated"
import Modal from "../../../modal/modal"
import "./ChangeStudentGroup.scss"
import Select from "../../../select/select"
import { GetAllTeacherClassesBySubsidiary, PostChangeStudentGroup } from "../../../../utils/Apis/apis"
import { useNavigate } from "react-router-dom"
import Autocomplete from "../../../../DesignSystem/Molecules/Autocomplete/Autocomplete"
import GroupAutocompleteOption from "../../Groups/GroupAutocompleteOption/GroupAutocompleteOption"

const ChangeStudentGroup = ({ isOpen, handleCancel, selectedGroup, subsidiaryList, showAlert, studentId, refreshData }) => {
    const [actualGroupId, setActualGroupId] = useState('')
    const [actualGroup, setActualGroup] = useState('')
    const [selectedSubsidiary, setSelectedSubsidiary] = useState(selectedGroup.subsidiary || '')
    const [classesList, setClassesList] = useState([])
    const [inputSelectedGroup, setInputSelectedGroup] = useState(null)
    const [disableButton, setDisableButton] = useState(false)
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        const controller = new AbortController();

        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await GetAllTeacherClassesBySubsidiary(selectedSubsidiary);
                if (controller.signal.aborted) return;

                if (response.auth === false) {
                    navigate("/login");
                    return;
                }
                const studentClassesArray = response.teacherClasses.filter((v) => v.type_class !== null && v.type_class.id === selectedGroup.class_type && v.is_finished === 0 && v.st === 0);
                const formatted = studentClassesArray.map(c => ({
                    id: c.id,
                    name: `Grupo #${c.id} / ${c.teacher.name || 'Maestro no asignado'} / ${c.is_online === true || c.is_online === 1 || c.is_online === '1' ? 'Online' : 'Presencial'} / ${c.full_dayclass} / ${c.level.name}`,
                    class_info: {
                        teacher: { id: c.teacher.id, name: c.teacher.name },
                        class_day: c.class_day,
                        time: { start: c.time.start, end: c.time.end },
                        level: { id: c.level.id, name: c.level.name },
                        date: { start: c.date.start },
                        is_online: c.is_online,
                        is_finished: c.is_finished,
                        st: c.st,
                        subsidiary: c.subsidiary.name,
                        isOnline: c.is_online ? "En línea" : "Presencial",
                        class_type: c.type_class.id,
                    }
                }))
                setClassesList(formatted);
            } catch (err) {
                if (!controller.signal.aborted) {
                    console.error("ERROR AL OBTENER CLASES:", err); // Agrega esto
                    setError("Error al cargar los grupos");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };
        fetchData();

        return () => controller.abort();
    }, [selectedSubsidiary]);

    useEffect(() => {
        if (classesList.length !== 0) {
            const classFilter = classesList.find((v) => v.id === selectedGroup.id)
            if (classFilter) {
                setActualGroupId(classFilter.id)
                setActualGroup(classFilter.name)
            } else {
                setActualGroup('Grupo no encontrado en esta sucursal');
            }
        }
    }, [classesList])
    const handleSubsidiaryChange = (v) => {
        setSelectedSubsidiary(v)
    }
    // Función para construir el nombre completo
    const getFullName = (classes) => {
        return `${classes.name}`;
    };

    const handleChangeGroup = (v) => {
        setInputSelectedGroup(v)
    }

    const handleConfirmChange = async () => {
        setDisableButton(true)
        if (inputSelectedGroup === null || Object.keys(inputSelectedGroup).length === 0) {
            setDisableButton(false)

            return showAlert('info', 'No ha seleccionado el grupo al que desa cambiar')
        }
        if (parseInt(actualGroupId) === parseInt(inputSelectedGroup.id)) {
            setDisableButton(false)
            return showAlert('info', 'El alumno actualmente pertenece a este grupo')

        }
        const postChangeGroup = await PostChangeStudentGroup(studentId, actualGroupId, inputSelectedGroup.id)
        if (postChangeGroup.status === 200) {
            showAlert('success', postChangeGroup.message)
            refreshData()
            setTimeout(() => {
                setDisableButton(false)
                handleCancel()
            }, 3000);

        } else {
            setDisableButton(false)
            showAlert('danger', postChangeGroup.message)
        }
    }
    return (
        <Modal onClose={handleCancel} isOpen={isOpen} overlayClick={false}>
            <div className="change-student-group">
                <h1 className="title-1">Cambiar alumno de grupo</h1>
                {/*Remplazar inputs por selects de busqueda */}
                <InputAnimated placeholder={'Grupo actual'} value={actualGroup} readOnly />
                <Select placeholder={'Selecciona sucursal'} value={selectedSubsidiary} options={subsidiaryList} onChange={(e) => handleSubsidiaryChange(e.target.value)} />
                <Autocomplete
                    options={classesList}
                    renderOption={(option) => <GroupAutocompleteOption id={option.id} group={option.class_info} />}
                    dropdownClassName="group-autocomplete-dropdown"
                    maxVisibleOptions={8}
                    getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
                    value={
                        inputSelectedGroup
                    } // Aquí pasas el objeto completo
                    isOptionEqualToValue={(option, value) => option.id === value.id} // Comparación basada en el 'id'
                    placeholder={"Buscar Grupo..."}
                    onChange={handleChangeGroup}

                />
                <section className='confirm-buttons-section'>
                    <Button disabled={disableButton} backgroundColor="red" text="Cancelar" onClick={handleCancel} />
                    <Button disabled={disableButton} backgroundColor="blue" text="Confirmar" onClick={handleConfirmChange} />
                </section>
            </div>
        </Modal>
    )
}
export default ChangeStudentGroup
